module.exports = __webpack_public_path__ + "media/images/photo10-4a87d4dc2a75819030e5216659b236ba.png";